var popfindConf = popfindConf || {};
let thisUid = "0bfc428aeb104fddaeb8abb82594a119u" //本番用
// let thisUid = "d5f63292e9ab46b68b780b27cf6e0ac3u", //検証用
popfindConf["data-sitesearch"] = {
	uid: thisUid,
	mode: "sitesearch",
	resultCountList: [10, 20, 30], //10, 20, 30で表示件数を指定
	inputId: "q,q2", //検索ボックスのID要素を指定
	allAsyncUpdateHook: () => {
		const item = document.querySelectorAll('._searchresults ._items ._title a');
		if(item.length) {
			item.forEach(ele => {
				let thisHref = ele.getAttribute('href');
				if(thisHref.indexOf('www.nisshin.com') !== -1) {
					ele.insertAdjacentHTML('afterbegin', '<span class="__label">日清製粉グループ</span>')
				} else if(thisHref.indexOf('www.nisshin-seifun-welna.com/index') !== -1) {
					ele.insertAdjacentHTML('afterbegin', '<span class="__label _welna">日清製粉ウェルナ</span>');
				}
			});
		}
	}
};
(function () {
	var s = document.createElement("script");
	s.charset = "utf-8";
	s.src = "//popfind.probo.biz/current/js/popfind.min.js";
	document.getElementsByTagName("head")[0].appendChild(s);
})();
var poplink3 = [
	{
		uid: thisUid,
		deviceType: { desktop: 'pcia', mobile: 'spia' },//レスポンシブ用
		target: "#q"
	}
];
// #q2がある場合のみ追加
if(document.querySelector('input[type="search"][id="q2"]')) {
	poplink3.push({	
		uid: thisUid,
		deviceType: { desktop: 'pcia', mobile: 'spia' },//レスポンシブ用
		target: "#q2"
	})
}
(function() {
	var s = document.createElement("script");
	s.charset = "utf-8";
	s.src = "//poplink-f.probo.biz/pl3/poplink3.js";
	document.getElementsByTagName("head")[0].appendChild(s);
})();

